// export const server = "http://localhost:8000";
export const server = "https://steward-cars-rentals-server.vercel.app";
